enum Status {
    Aceptada = 0,
    Procesada = 1,
    Caducada = 2,
    Eliminada = 3,
    Anulada = 4,
    Pendiente = 5,
    No_Procesada = 6,
    Sin_Vigencia = 7,
    Modificación = 8,
    Preaprobado = 9,
    Cotizado = 10,
};

export default Status;